import { IState } from '../../store';

export function getBookedFromDeveloper(state: IState): boolean | undefined {
  return state.offerData.isBookedFromDeveloper ? true : undefined;
}
